var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecksquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1757471410661,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 10420,
    width: 14,
    height: 14,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M475.776 715.776a46.208 46.208 0 0 1-35.392-14.976l-234.24-234.56a49.28 49.28 0 0 1 0-69.824 50.816 50.816 0 0 1 70.784 0l197.12 197.952 421.376-417.536c20.16-19.968 52.224-19.968 70.72 0 20.224 19.968 20.224 51.584 0 69.824l-455.04 454.144a46.208 46.208 0 0 1-35.328 14.976z",
    fill: "#172B4D",
    "p-id": 10421
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M856.64 938.688H93.248a49.28 49.28 0 0 1-50.56-49.92V135.232a49.28 49.28 0 0 1 50.56-49.92h672.384a49.28 49.28 0 0 1 50.56 49.92 49.28 49.28 0 0 1-50.56 49.92H143.808v653.696h662.272V512.832a49.28 49.28 0 0 1 50.56-49.92 49.28 49.28 0 0 1 50.56 49.92v377.6c0 26.624-21.952 48.256-50.56 48.256z",
    fill: "#172B4D",
    "p-id": 10422
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecksquare);
export default __webpack_public_path__ + "static/media/checksquare.13ed0d43.svg";
export { ForwardRef as ReactComponent };